//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.
//

export const PROPOSALS_SCHEMA_VERSION = '1.0'

export interface ProposalsConfig {
  viewType: ViewType
  identifierPreference?: 'CUSIP' | 'ISIN'
}

export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}
